import { useQuery } from '@tanstack/react-query';
import { getAllPropertyDocumentTypes } from '../service';

function useDocumentTypes() {
    const documentTypesQuery = useQuery({
        queryKey: ['property-documents', 'types'],
        queryFn: async () => getAllPropertyDocumentTypes(),
    });

    return documentTypesQuery;
}

export { useDocumentTypes };
